import {
  API_DICTIONARY,
  HTTP_METHODS,
  ResponseWithPagination,
  TOptionsResponse
} from '../../constants'
import Fetcher from '../../services/Fetcher'

const fetcher = new Fetcher({})

export const fetchStateOptions = async (country = 'US') =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.USERS}${API_DICTIONARY.STATES}?country=${country}`,
    method: HTTP_METHODS.GET
  })
export const fetchVendorOptions = async () =>
  fetcher.request<unknown, ResponseWithPagination<TOptionsResponse>>({
    url: `${API_DICTIONARY.VENDORS}${API_DICTIONARY.OPTIONS}`,
    method: HTTP_METHODS.GET
  })
